import React, { useState } from 'react';
import { HGTable } from 'components/HGTable';
import { upgradeEventLogsColumns } from './logDetailsTableColumns';
import { useUpgradeLogs } from './service';

const LogTable = () => {
    const { data: upgradeLogs, isLoading } = useUpgradeLogs();
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <>
            <h4 className="px-5 pt-5 text-lg font-semibold">Upgrade Event Logs</h4>
            <HGTable
                columns={upgradeEventLogsColumns}
                data={upgradeLogs ?? []}
                loading={isLoading}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                currentPage={1}
                setCurrentPage={() => {}}
                pageSize={upgradeLogs?.length ?? 0}
                totalItems={upgradeLogs?.length ?? 0}
            />
        </>
    );
};

export default LogTable;
